/**
 * School fees "outstanding" for list filters — aligned with calcoutstanding() in tableschoolfees.js
 * (per-row contribution to the footer total).
 */

function normalizeClassList(raw) {
    if (raw == null) return [];
    if (!Array.isArray(raw)) return [];
    if (raw.length === 1 && Array.isArray(raw[0])) return raw[0];
    return raw;
}

function getClassfeesByClassname(classList, classname) {
    const list = normalizeClassList(classList);
    if (classname == null || classname === '') return 0;
    const c = list.find((bug) => bug && bug.classname === classname);
    const raw = c?.classfees;
    if (raw == null || raw === '') return 0;
    const n = parseFloat(raw);
    return Number.isFinite(n) ? n : 0;
}

function financeTermValue(term) {
    if (term == null) return null;
    if (typeof term === 'object') {
        const v = term.name ?? term.term ?? term.value;
        return v != null ? v : null;
    }
    return term;
}

/**
 * Matches tableschoolfees UI when comparing latest finance row to current school term.
 */
export function financeRecordMatchesMainTerm(latestTerm, mainterm) {
    if (mainterm == null || mainterm === '' || mainterm === 'none') return false;
    const a = financeTermValue(latestTerm);
    const b = financeTermValue(mainterm);
    if (a != null && b != null && String(a) === String(b)) return true;
    return latestTerm === mainterm;
}

/**
 * @param {object} row student row with finance[]
 * @param {Array} classList Class_ from redux (may be double-wrapped)
 * @param {string|object} mainterm current term from school details
 * @returns {number} amount still counted as outstanding for filters
 */
export function getStudentSchoolFeesOutstanding(row, classList, mainterm) {
    const classes = normalizeClassList(classList);
    if (!row || !Array.isArray(row.finance)) return 0;
    if (row.finance.length === 0) {
        return classes.length ? parseFloat(getClassfeesByClassname(classes, row.class_).toFixed(2)) : 0;
    }
    if (classes.length === 0) return 0;
    const latest = row.finance[row.finance.length - 1];
    if (!latest) return 0;

    const matchesMain = financeRecordMatchesMainTerm(latest.term, mainterm);

    if (row.finance.length !== 0 && matchesMain) {
        return parseFloat(latest.balance) || 0;
    }
    if (row.finance.length !== 0 && latest.totalfees != null) {
        return parseFloat(
            (
                getClassfeesByClassname(classes, row.class_) +
                (parseFloat(latest.balance) || 0) +
                (parseFloat(latest.Arrears) || 0)
            ).toFixed(2)
        );
    }
    return parseFloat(getClassfeesByClassname(classes, row.class_).toFixed(2));
}

export const SCHOOL_FEES_OUTSTANDING_EPS = 1e-4;

export function isSchoolFeesDebtorRow(row, classList, mainterm) {
    return getStudentSchoolFeesOutstanding(row, classList, mainterm) > SCHOOL_FEES_OUTSTANDING_EPS;
}

export function isSchoolFeesCompleteRow(row, classList, mainterm) {
    return getStudentSchoolFeesOutstanding(row, classList, mainterm) <= SCHOOL_FEES_OUTSTANDING_EPS;
}
